module.exports = __webpack_public_path__ + "static/network-emulation-a40e8d6610491304fb719ec7aae97af2.png";